import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { changes, fields } from 'src/components/utils/fields'
import { useMediaQuery } from '@mui/material'
import { BufferService, LoadingContext, M_Button, M_ElementDrawer, M_Fieldset, M_Header, M_SimpleTable } from 'src/M_Components'
import { Anchor, ArticleOutlined, CalendarMonthOutlined, Close, DirectionsBoat, FunctionsOutlined, Group, Inventory2Outlined, Refresh, Search, Settings } from '@mui/icons-material'

export const QuoteCrud = () => {
    const [id, setId] = useState(sessionStorage.getItem('selectedTab'))
    const { t } = useTranslation()
    const ctx = useContext(LoadingContext)
    const [data, setData] = useState({})
    const [open, setOpen] = useState(false)
    const [passedRow, setPassedRow] = useState({})
    const [operation, setOperation] = useState('')
    const [isFirstTime, setIsFirstTime] = useState(true)

    const accountService = new BufferService('Account')

    const sessionKeys = ['operation', 'data', 'open', 'passedRow']

    const matches = useMediaQuery('(min-width:1800px)')
    const matches2 = useMediaQuery('(min-width:1700px)')
    const matches3 = useMediaQuery('(min-width:1490px)')
    const matches4 = useMediaQuery('(min-width:1450px)')
    const matches5 = useMediaQuery('(min-width:1420px)')
    const matches6 = useMediaQuery('(min-width:1380px)')
    const matches7 = useMediaQuery('(min-width:1280px)')
    const matches8 = useMediaQuery('(min-width:1230px)')
    const matches9 = useMediaQuery('(min-width:1190px)')
    const matches10 = useMediaQuery('(min-width:1150px)')
    const matches11 = useMediaQuery('(min-width:970px)')
    const matches12 = useMediaQuery('(min-width:930px)')
    const matches13 = useMediaQuery('(min-width:850px)')
    const matches14 = useMediaQuery('(min-width:870px)')
    const matches15 = useMediaQuery('(min-width:615px)')
    const matches16 = useMediaQuery('(min-width:440px)')

    const multipleOptions = [
        { label: t('Equipment'), value: 'equipment' },
        { label: t('Document'), value: 'document' },
        { label: t('Process'), value: 'process' },
        { label: t('Weight'), value: 'weight' },
        { label: t('Measures'), value: 'measure' },
        { label: t('Percentage'), value: 'percentage' },
        { label: t('Other'), value: 'other' },
        { label: t('TEU'), value: 'teu' },
        { label: t('Quantity'), value: 'quantity' },
        { label: t('KG 6 DM3'), value: 'kg6dm3' },
        { label: t('KG'), value: 'kg' },
    ]

    const payingCompanyOptions = [
        { label: t('Client'), value: 'client' },
        { label: t('Other - Foreign Currency'), value: 'foreign' },
        { label: t('Invoice'), value: 'invoice' },
        { label: t('Shipper'), value: 'shipper' },
        { label: t('Consignee'), value: 'consignee' },
        { label: t('Notify'), value: 'notify' },
        { label: t('Agent'), value: 'agent' },
        { label: t('Feeder'), value: 'feeder' },
        { label: t('Other'), value: 'other' },
    ]

    const payableHowOptions = [
        { label: t('Prepaid'), value: 'prepaid' },
        { label: t('Collect'), value: 'collect' },
        { label: t('Prep. Else'), value: 'prepElse' },
        { label: t('Coll. Else'), value: 'collElse' },
        { label: t('Other'), value: 'other' },
        { label: t('BLANK'), value: 'blank' },
    ]

    const QuoteInfoFields = [
        { display: t('QuoteName'), required: false, code: 'quoteName', type: 'text' },
        { display: t('Currency'), required: true, code: 'quoteCurrencyCode', type: 'foreignKey', entity: 'Currency', filterField: 'code', labelFields: ['Code'], fields: [{ key: 'Code', value: 'quoteCurrencyCode' }, { key: 'Id', value: 'quoteCurrencyId' }], },
        { display: t('Reference'), required: false, code: 'reference', type: 'text' },
        { display: t('Remarks'), required: false, code: 'remarks', type: 'textArea' },
    ]

    const QuoteDatesFields = [
        { display: t('StartDate'), required: true, code: 'startDate', type: 'date', },
        { display: t('DueDate'), required: true, code: 'dueDate', type: 'date', },
        { display: t('ValidFrom'), required: true, code: 'validFrom', type: 'date', },
        { display: t('ValidTo'), required: true, code: 'validTo', type: 'date', },
    ]

    const QuotePortsFields = [
        { display: t('OriginalPort'), required: false, code: 'originalPortName', type: 'foreignKey', entity: 'Location', filterField: 'LocationName', labelFields: ['LocationName'], fields: [{ key: 'LocationName', value: 'originalPortName' }, { key: 'Id', value: 'originalPortNameId' }], },
        { display: t('LoadingPort'), required: true, code: 'loadingPortName', type: 'foreignKey', entity: 'Location', filterField: 'LocationName', labelFields: ['LocationName'], fields: [{ key: 'LocationName', value: 'loadingPortName' }, { key: 'Id', value: 'loadingPortNameId' }], },
        { display: t('DischargePort'), required: true, code: 'dischargePortName', type: 'foreignKey', entity: 'Location', filterField: 'LocationName', labelFields: ['LocationName'], fields: [{ key: 'LocationName', value: 'dischargePortName' }, { key: 'Id', value: 'dischargePortNameId' }], },
        { display: t('FinalPort'), required: false, code: 'finalPortName', type: 'foreignKey', entity: 'Location', filterField: 'LocationName', labelFields: ['LocationName'], fields: [{ key: 'LocationName', value: 'finalPortName' }, { key: 'Id', value: 'finalPortNameId' }], },
        { display: t('TransitTime'), required: false, code: 'transitTime', type: 'text' },
    ]

    const QuoteEntitiesFields = [
        { display: t('Company'), required: true, code: 'company', type: 'select', extraField: 'accountId' },
        { type: !matches13 && 'whitespace' },
        { display: t('Client'), code: 'clientCode', type: 'disabled', },
        { display: t('ClientVAT'), code: 'clientVat', type: 'disabled', },
        { type: !matches6 && matches13 && 'whitespace' },
        { display: t('Shipper'), required: false, code: 'shipperCode', type: 'foreignKey', entity: 'Account', filterField: 'AccountCode', labelFields: ['AccountCode'], fields: [{ key: 'AccountCode', value: 'shipperCode' }, { key: 'AccountVATNumber', value: 'shipperVat' }, { key: 'Id', value: 'shipperId' }], },
        { display: t('ShipperVAT'), code: 'shipperVat', type: 'disabled', },
        { type: matches6 && 'whitespace' },
        { type: matches6 && 'whitespace' },
        { type: matches6 && 'whitespace' },
        { type: !matches6 && matches13 && 'whitespace' },
        { display: t('Consignee'), required: false, code: 'consigneeCode', type: 'foreignKey', entity: 'Account', filterField: 'AccountCode', labelFields: ['AccountCode'], fields: [{ key: 'AccountCode', value: 'consigneeCode' }, { key: 'AccountVATNumber', value: 'consigneeVat' }, { key: 'Id', value: 'consigneeId' }], },
        { display: t('ConsigneeVAT'), code: 'consigneeVat', type: 'disabled', },
    ]

    const EquipmentFields = [
        { display: t('Quantity'), code: 'quantity', type: 'number' },
        { display: t('EquipmentType'), required: true, code: 'equipmentType', type: 'foreignKey', entity: 'EquipmentType', filterField: 'EquipmentTypeCode', labelFields: ['EquipmentTypeLenght', 'EquipmentTypeCode'], fields: [{ key: 'EquipmentTypeLenght', value: 'equipmentTypeLenght' }, { key: 'EquipmentTypeCode', value: 'equipmentTypeCode' }, { key: 'Id', value: 'equipmentTypeId' }], },
        { type: !matches && 'whitespace' || !matches11 && 'whitespace' }
    ]

    const GoodsFields = [
        { display: t('CommodityCode'), code: 'commodityCode', type: 'foreignKey', entity: 'Commodity', filterField: 'CommodityCode', labelFields: ['CommodityCode'], fields: [{ key: 'CommodityCode', value: 'commodityCode' }, { key: 'CommodityName', value: 'commodityName' }, { key: 'Id', value: 'commodityId' }], },
        { display: t('CommodityName'), code: 'commodityName', type: 'foreignKey', entity: 'Commodity', filterField: 'CommodityName', labelFields: ['CommodityName'], fields: [{ key: 'CommodityCode', value: 'commodityCode' }, { key: 'CommodityName', value: 'commodityName' }, { key: 'Id', value: 'commodityId' }], },
        { display: t('UNNo'), code: 'dangerousGoodsCode', type: 'foreignKey', entity: 'DangerousGoods', filterField: 'Code', labelFields: ['Code', 'Name'], fields: [{ key: 'Id', value: 'dangerousGoodsId' }, { key: 'Code', value: 'dangerousGoodsCode' }, { key: 'Class', value: 'dangerousGoodsClass' }], },
        { display: t('GrossWeight'), code: 'grossWeight', type: 'number' },
        { type: 'whitespace' },
        { type: !matches4 ? '' : 'whitespace' },
        { type: !matches4 ? '' : 'whitespace' },
    ]

    const ChargesFields = [
        { size: 150, display: t('ServiceCode'), required: true, code: 'serviceCode', type: 'foreignKey', entity: 'ServiceType', filterField: 'code', labelFields: ['Code'], fields: [{ key: 'Code', value: 'serviceCode' }, { key: 'Name', value: 'serviceName' }, { key: 'Id', value: 'serviceId' }], },
        { display: t('ServiceName'), required: true, code: 'serviceName', type: 'foreignKey', entity: 'ServiceType', filterField: 'code', labelFields: ['Name'], fields: [{ key: 'Code', value: 'serviceCode' }, { key: 'Name', value: 'serviceName' }, { key: 'Id', value: 'serviceId' }], },
        { size: 100, display: t('CostValue'), required: false, code: 'costValue', type: 'number' },
        { size: 150, display: t('Currency'), required: true, code: 'currencyCode', type: 'foreignKey', entity: 'Currency', filterField: 'code', labelFields: ['Code'], fields: [{ key: 'Code', value: 'currencyCode' }, { key: 'Id', value: 'currencyId' }], },
        { size: 100, display: t('SalesValue'), required: false, code: 'salesValue', type: 'number' },

        { size: 100, display: t('Quantity'), required: false, code: 'quantity', type: 'number' },
        { size: 200, display: t('Multiple'), required: false, code: 'multiple', type: 'select', options: multipleOptions, extraField: 'multipleValue' },
    ]

    const RestrictionsFields = [
        { display: t('EquipmentType'), required: false, code: 'restrictionsEquipmentType', type: 'foreignKey', entity: 'equipmentType', filterField: 'EquipmentTypeCode', labelFields: ['EquipmentTypeLenght', 'EquipmentTypeCode'], fields: [{ key: 'EquipmentTypeLenght', value: 'restrictionsSize' }, { key: 'EquipmentTypeCode', value: 'restrictionsEquipmentType' }, { key: 'Id', value: 'restrictionsEquipmentTypeId' }], },
    ]

    const ManifestFields = [
        { display: t('Value'), required: false, code: 'manifestValue', type: 'number' },
        { display: t('Multiple'), required: false, code: 'manifestMultiple', type: 'select', options: multipleOptions, extraField: 'manifestMultipleValue' },
    ]

    const DetailsFields = [
        { display: t('LumpSum'), required: false, code: 'lumpSumCode', type: 'foreignKey', entity: 'LumpSum', filterField: 'code', labelFields: ['Code'], fields: [{ key: 'Code', value: 'lumpSumCode' }, { key: 'Name', value: 'lumpSumName' }, { key: 'Id', value: 'lumpSumId' }], },
        { display: t('CostCurrency'), required: false, code: 'costCurrencyCode', type: 'foreignKey', entity: 'Currency', filterField: 'code', labelFields: ['Code'], fields: [{ key: 'Code', value: 'costCurrencyCode' }, { key: 'Id', value: 'costCurrencyId' }], },
        { display: t('PayableHow'), required: false, code: 'payableHow', type: 'select', options: payableHowOptions, extraField: 'payableHowValue' },
        { display: t('PayingCompany'), required: false, code: 'payingCompany', type: 'select', options: payingCompanyOptions, extraField: 'payingCompanyValue' },
        { display: t('ManifestCurrency'), required: false, code: 'manifestCurrencyCode', type: 'foreignKey', entity: 'Currency', filterField: 'code', labelFields: ['Code'], fields: [{ key: 'Code', value: 'manifestCurrencyCode' }, { key: 'Id', value: 'manifestCurrencyId' }], },
        { display: t('Supplier'), required: false, code: 'supplierCode', type: 'foreignKey', entity: 'Account', filterField: 'AccountCode', labelFields: ['AccountCode'], fields: [{ key: 'AccountCode', value: 'supplierCode' }, { key: 'Id', value: 'supplierId' }], },

    ]

    const Totalizador = [
        { display: t('TotalCharges'), code: 'totalCharges' },
        { display: t('Currency'), code: 'totalCurrency' },
        { display: t('Markup'), code: 'totalMarkup' },
        { display: t('TotalCost'), code: 'totalCost' },
        { display: t('TotalSales'), code: 'totalSales' },
        { display: t('Profit'), code: 'totalProfit' }
    ]





    const currencyOptions = [
        { label: '€', value: 'euro' },
        { label: '$', value: 'dollar' },
    ]


    useEffect(() => {
        if (isFirstTime) {
            ctx.setIsLoad(true)
            getSessionStorageData(id)
            setIsFirstTime(false)
            sessionStorage.setItem(`tab${id}`, JSON.stringify(sessionKeys))
        }
    }, [])

    useEffect(() => {
        const newId = sessionStorage.getItem('selectedTab')
        if (newId !== id) {
            setId(newId)
            getSessionStorageData(newId)
        }
    })

    useEffect(() => {
        sessionKeys.forEach((key) => {
            sessionStorageMachine(id, key, key)
        })
        // eslint-disable-next-line
    }, [id, operation, data,])

    const sessionStorageMachine = (id, key, value) => {
        if (eval(value) instanceof Object && Object.keys(eval(value)).length === 0) return
        if (eval(value) instanceof String && eval(value) === '') return
        if (eval(value) instanceof Number && eval(value) === '') return

        // eslint-disable-next-line
        if (eval(value) instanceof Map) {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(Array.from(eval(value))))
        } else {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(eval(value)))
        }
    }

    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true)
        const tempO = JSON.parse(sessionStorage.getItem(`${sessionID}operation`))
        const tempD = JSON.parse(sessionStorage.getItem(`${sessionID}data`))
        const tempOS = JSON.parse(sessionStorage.getItem(`${sessionID}open`))
        const tempPR = JSON.parse(sessionStorage.getItem(`${sessionID}passedRow`))

        if ((tempO && tempO !== '') || (tempD && Object.keys(tempD).length !== 0) || tempOS || (tempPR && Object.keys(tempD).length !== 0)) {

            setOperation(new String(tempO))
            setData(new Object(tempD))
            setOpen(tempOS)
            setPassedRow(tempPR)
            ctx.setIsLoad(false)

            return
        }
        get()
    }

    const get = () => {
        ctx.setIsLoad(false)

        changes('totalCurrency', '€', setData)
        let counter = 1
        newCharge(true, counter)
        changes('counterCharges', counter + 1, setData)

        getCompanies()
    }

    const getCompanies = () => {
        let tempCompanies = JSON.parse(sessionStorage.getItem('companies'))
        if (tempCompanies.lenght === 0) {
            ctx.toastMessages('error', 'User has no companies!', '')
        }
        if (tempCompanies.lenght === 1) {
            getAccount(tempCompanies[0])
        }

        changes('companyOptions', tempCompanies.map(field => { return { label: field.Name, value: field.AccountId, ...field } }), setData)
    }

    const companyFunc = (row, fields, obj) => {
        if (obj) {
            getAccount(obj.value)
            changes('company', obj.label, setData)
            changes('accountId', obj.value, setData)
        }
    }

    const getAccount = (accountId) => {
        if (accountId) {
            accountService.getId(accountId).then(res => {
                if (res.name === 'AxiosError') {
                    ctx.toastMessages('error', 'Couldnt fetch Account!', '')
                    return
                }
                changes('clientCode', res.AccountCode, setData)
                changes('clientVat', res.AccountVATNumber, setData)
                changes('userCompanyId', res.UserCompanyId, setData)
            })
        } else {
            changes('clientCode', '', setData)
            changes('clientVat', '', setData)
            changes('userCompanyId', '', setData)
        }
    }

    const equipmentFunc = (row, fields, obj) => {
        if (obj) {
            changes('equipmentTypeLenght', obj['EquipmentTypeLenght'], setData)
            changes('equipmentTypeCode', obj['EquipmentTypeCode'], setData)
            changes('equipmentTypeId', obj['Id'], setData)
            changes('equipmentType', `${obj['EquipmentTypeLenght']}${obj['EquipmentTypeCode']}`, setData)

        }
    }

    const newCharge = (isFIrst, counter) => {
        let newObj = {}
        let newArray = isFIrst && [] || data['charges']

        ChargesFields.forEach(obj => {
            newObj[obj?.code] = ''
            if (obj?.labelFields) {
                obj?.fields.forEach(extra => {
                    newObj[extra?.value] = ''
                })
            }
            if (obj?.extraField) {
                newObj[obj?.extraField] = ''
            }
        })
        newObj['id'] = counter
        newArray.push(newObj)
        changes('charges', newArray, setData)
    }

    const refreshQuote = () => {
        get()
    }

    const addEquipment = () => {
        let counter = data?.EquipmentCounter || 1
        let newObj = {}
        let throwError = false
        EquipmentFields.forEach(obj => {
            if (obj?.required && !data?.[obj.code]) {
                ctx.toastMessages('error', [obj.display] + ' field is required', '')
                throwError = true
            }
        })
        if (throwError) {
            return
        }
        EquipmentFields.forEach(obj => {
            if (obj.code === 'quantity' && (!data?.[obj.code] || data?.[obj.code] < 1)) {
                newObj[obj.code] = 1
            } else {
                newObj[obj.code] = data?.[obj.code] || ''
            }
            changes(obj.code, '', setData)
            if (obj.labelFields) {
                obj.fields.forEach(extra => {
                    newObj[extra.value] = data[extra.value] || ''
                    changes(extra.value, '', setData)
                }
                )
            }
        })

        const newEquipment = data?.Equipments || []
        // newEquipment 
        newObj.Id = counter
        changes('EquipmentCounter', counter + 1, setData)
        newEquipment.push(newObj)
        changes('Equipments', newEquipment, setData)
    }

    const deleteEquipment = (row) => {
        const newEquipments = data?.Equipments.filter(equip => equip.Id !== row.Id)
        changes('Equipments', newEquipments, setData)
    }

    const addGoods = () => {
        let counter = data?.GoodsCounter || 1
        let newObj = {}
        GoodsFields.forEach(obj => {
            newObj[obj.code] = data?.[obj.code] || ''
            changes(obj.code, '', setData)
            if (obj.labelFields) {
                obj.fields.forEach(extra => {
                    newObj[extra.value] = data[extra.value] || ''
                    changes(extra.value, '', setData)
                }
                )
            }
        })

        const newGoods = data?.Goods || []
        // newEquipment 
        newObj.Id = counter
        changes('GoodsCounter', counter + 1, setData)
        newGoods.push(newObj)
        changes('Goods', newGoods, setData)
    }

    const deleteGoods = (row) => {
        const newGoods = data?.Goods.filter(good => good.Id !== row.Id)
        changes('Goods', newGoods, setData)
    }

    const getCharges = () => {
        //! NEEDS AN ENDPOINT
    }

    const settingsCharges = (row) => {
        setPassedRow(row)
        setOpen(true)
    }

    const deleteCharges = (row) => {
        const newCharges = data?.charges.filter(charge => charge.id !== row.id)
        changes('charges', newCharges, setData)
    }

    const chargesElements = (row, field, index) => {
        if (row.id !== data.charges[data.charges.length - 1].id || field.code === 'serviceCode' || field.code === 'serviceName') {
            return <div>
                {fields(field, index, row, setData, true, saveChargesValues, field?.size, field?.options)}
            </div>
        } else {
            return <div>
                {fields({ ...field, type: 'disabled' }, index, row, setData, true, saveChargesValues, field?.size)}
            </div>
        }
    }

    const saveChargesValues = (row, fields, obj) => {
        if (fields.code === 'serviceCode' || fields.code === 'serviceName') {
            if (row.id === data.charges[data.charges.length - 1].id) {

                let counter = data['counterCharges']
                newCharge(false, counter)
                changes('counterCharges', counter + 1, setData)
            }
        }

        let oldArray = data['charges']

        let newArray = oldArray.map(old => {
            if (old.id === row.id) {
                let newObj = { ...old }
                if (fields.type === 'foreignKey') {
                    fields.fields.forEach(field => {
                        if (obj) {
                            newObj[field.value] = obj[field.key]
                        } else {
                            newObj[field.value] = ''
                        }
                    })

                } else if (fields.type === 'select') {
                    if (obj) {
                       
                        newObj[fields.code] = obj.label
                        newObj[fields.extraField] = obj.value
                    } else {
                        newObj[fields.code] = ''
                        newObj[fields.extraField] = ''
                    }
                } else {
                    newObj[fields.code] = obj
                }
                return newObj
            }
            return old
        })
        changes('charges', newArray, setData)
    }

    const closeSettings = () => {
        setPassedRow({})
        setOpen(false)
    }

    const saveSettings = () => {
        const oldArray = data['charges']
        const newArray = oldArray.map(old => {
            if (old.id === passedRow.id) {
                return passedRow
            }
            return old
        })
        changes('charges', newArray, setData)
        setPassedRow({})
        setOpen(false)
    }

    const getSum = (field) => {
        let sum = 0
        data?.charges?.forEach(charge => {
            sum = sum + Number(charge[field])
        })
        return sum || 0
    }

    const getMarkup = () => {
        return (((getSum('salesValue') - getSum('costValue')) / getSum('costValue') || 0) * 100).toFixed(2)
    }

    const getProfit = () => {
        return (getSum('salesValue') - getSum('costValue')).toFixed(2)
    }

    const calculateTotalSum = (dta, eventData, type) => {
        let total = 0
        eventData?.props?.value.filter(obj => obj.lumpSumCode === dta.lumpSumCode).forEach(obj => {
            total = total + Number(obj[type])
        })
        return total
    }

    const calculateTotalProfit = (dta, eventData) => {
        let totalCost = 0
        let totalSales = 0

        eventData?.props?.value.filter(obj => obj.lumpSumCode === dta.lumpSumCode).forEach(obj => {
            totalCost = totalCost + Number(obj['costValue'])
            totalSales = totalSales + Number(obj['salesValue'])
        })
        const total = (totalSales - totalCost).toFixed(2)
        return total > 0 && `+${total}` || total
    }

    const onSave = () => {
        console.log(data)
        //! NEEDS AN ENDPOINT
    }


    return (
        <div >
            <M_Header
                element={
                    <>
                        <M_Button
                            tooltip={t("Refresh")}
                            icon={<Refresh />}
                            label={t("Refresh")}
                            onClick={() => refreshQuote()}
                        />
                        <M_Button
                            tooltip={t("Save")}
                            icon={<i className="pi pi-save "></i>}
                            label={t("Save")}
                            onClick={() => onSave()}
                        />
                    </>
                }
            />
            <div style={{ margin: '20px' }}>
                <div style={{ display: 'grid', gridTemplateColumns: !matches11 && 'auto ' || 'auto auto auto' }}>
                    <M_Fieldset
                        labelInside
                        label={<div style={{ display: 'flex', alignItems: 'center', fontSize: '25px', marginLeft: '10px' }}><DirectionsBoat style={{ marginRight: '10px', scale: '1.3' }} /> {t("QuoteInfo")}</div>}
                        elements={
                            <div style={{ display: 'grid', gridTemplateColumns: !matches15 && 'auto' || !matches11 && 'auto auto' || 'auto', justifyContent: 'space-evenly' }}>
                                {QuoteInfoFields.map((field, index) => {
                                    return <div key={index}>{fields(field, index, data, setData)}</div>
                                })}
                            </div>
                        }
                    />
                    <M_Fieldset
                        labelInside
                        label={<div style={{ display: 'flex', alignItems: 'center', fontSize: '25px', marginLeft: '10px' }}><CalendarMonthOutlined style={{ marginRight: '10px', scale: '1.3' }} /> {t("Dates")}</div>}
                        elements={
                            <div style={{ display: 'grid', gridTemplateColumns: !matches15 && 'auto' || !matches11 && 'auto auto' || !matches3 && 'auto' || ' auto auto', justifyContent: 'space-evenly' }}>
                                {QuoteDatesFields.map((field, index) => {
                                    return <div key={index}>{fields(field, index, data, setData)}</div>
                                })}
                            </div>
                        }
                    />
                    <M_Fieldset
                        labelInside
                        label={<div style={{ display: 'flex', alignItems: 'center', fontSize: '25px', marginLeft: '10px' }}><Anchor style={{ marginRight: '10px', scale: '1.3' }} /> {t("Ports")}</div>}
                        elements={
                            <div style={{ display: 'grid', gridTemplateColumns: !matches15 && 'auto' || !matches11 && 'auto auto' || !matches8 && 'auto' || 'auto auto', justifyContent: 'space-evenly' }}>
                                {QuotePortsFields.map((field, index) => {
                                    return <div key={index}>{fields(field, index, data, setData)}</div>
                                })}
                            </div>
                        }
                    />
                </div>
                <div>
                    <M_Fieldset
                        labelInside
                        label={<div style={{ display: 'flex', alignItems: 'center', fontSize: '25px', marginLeft: '10px' }}><Group style={{ marginRight: '10px', scale: '1.3' }} /> {t("Entities")}</div>}
                        elements={
                            <div style={{ display: 'grid', gridTemplateColumns: !matches15 && 'auto' || !matches13 && 'auto auto' || !matches6 && 'auto auto auto' || 'auto auto auto auto auto', justifyContent: 'space-evenly' }}>
                                {QuoteEntitiesFields.map((field, index) => {
                                    if (field.code === 'company') {
                                        return <div key={index}>{fields(field, index, data, setData, null, companyFunc, null, data['companyOptions'])}</div>
                                    }
                                    return <div key={index}>{fields(field, index, data, setData, null, null)}</div>
                                })}
                            </div>
                        }
                    />
                </div>
                <div style={{ display: !matches16 && 'flex' || 'grid', flexDirection: 'column', gridTemplateColumns: !matches12 && 'auto' || 'auto auto' }}>
                    <M_Fieldset
                        labelInside
                        label={<div style={{ display: 'flex', alignItems: 'center', fontSize: '25px', marginLeft: '10px' }}><i className="pi pi-box" style={{ marginRight: '10px', fontSize: '30px' }}></i>  {t("Equipment")}</div>}
                        elements={
                            <div>
                                <div style={{ display: 'grid', gridTemplateColumns: !matches15 && 'auto' || !matches12 && 'auto auto' || !matches2 && 'auto' || matches && 'auto auto auto' || 'auto auto', justifyContent: 'space-evenly' }}>
                                    {EquipmentFields.map((field, index) => {
                                        if (field.code === 'equipmentType') {
                                            return <div key={index}>{fields(field, index, data, setData, null, equipmentFunc)}</div>
                                        }
                                        return <div key={index}>{fields(field, index, data, setData)}</div>
                                    })}
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <M_Button
                                            bold
                                            normal
                                            hoverEffect
                                            label={t('Add')}
                                            labelColor={'var(--color-white)'}
                                            backgroundColor={'var(--color-green)'}
                                            borderColor={'var(--color-green)'}
                                            icon={<img src='/icons/svgsDaNet/plus-square.svg' alt={t("Add")} style={{ filter: 'brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7477%) hue-rotate(324deg) brightness(94%) contrast(109%)' }} className='iconCreateBooking' />}
                                            onClick={() => addEquipment()}
                                        />
                                    </div>
                                </div>
                                <div style={{ marginBottom: '20px' }}></div>
                                <M_SimpleTable
                                    rows={data['Equipments'] && data['Equipments'] || []}
                                    columns={[
                                        ...EquipmentFields.map(obj => { return { header: obj.display, field: obj.code } }).filter(obj => obj.type !== 'whiteSpace' || obj.type !== ''),
                                        { 'header': '', 'body': (row) => (<M_Button none icon={<Close style={{ color: 'var(--color-red)' }} />} onClick={() => deleteEquipment(row)} />) }
                                    ]}
                                />
                            </div>
                        }
                    />
                    <M_Fieldset
                        labelInside
                        label={<div style={{ display: 'flex', alignItems: 'center', fontSize: '25px', marginLeft: '10px' }}><Inventory2Outlined style={{ marginRight: '10px', scale: '1.3' }} /> {t("Goods")}</div>}
                        elements={
                            <div>
                                <div style={{ display: 'grid', justifyContent: 'center', gridTemplateColumns: !matches15 && 'auto' || !matches9 && 'auto auto' || !matches4 && 'auto auto auto' || 'auto auto auto auto', justifyContent: 'space-evenly' }}>
                                    {GoodsFields.map((field, index) => {
                                        return <div key={index}>{fields(field, index, data, setData)}</div>
                                    })}
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <M_Button
                                            bold
                                            normal
                                            hoverEffect
                                            label={t('Add')}
                                            labelColor={'var(--color-white)'}
                                            backgroundColor={'var(--color-green)'}
                                            borderColor={'var(--color-green)'}
                                            icon={<img src='/icons/svgsDaNet/plus-square.svg' alt={t("Add")} style={{ filter: 'brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7477%) hue-rotate(324deg) brightness(94%) contrast(109%)' }} className='iconCreateBooking' />}
                                            onClick={() => addGoods()}
                                        />

                                    </div>
                                </div>
                                <div style={{ marginBottom: '20px' }}></div>
                                <M_SimpleTable
                                    rows={data['Goods'] && data['Goods'] || []}
                                    columns={[
                                        ...GoodsFields.map(obj => { return { header: obj.display, field: obj.code } }).filter(obj => obj.type !== 'whiteSpace' || obj.type !== ''),
                                        { 'header': '', 'body': (row) => (<M_Button none icon={<Close style={{ color: 'var(--color-red)' }} />} onClick={() => deleteGoods(row)} />) }
                                    ]}
                                />
                            </div>
                        }
                    />
                </div>
                <M_Fieldset
                    labelInside
                    label={<div style={{ display: 'flex', alignItems: 'center', fontSize: '25px', marginLeft: '10px' }}><ArticleOutlined style={{ marginRight: '10px', scale: '1.3' }} /> {t("Charges")}</div>}
                    headerElement={
                        matches15 && <div style={{ margin: '20px' }}>
                            <M_Button
                                bold
                                normal
                                hoverEffect
                                label={t('LoadCharges')}
                                borderColor={'var(--color-blue)'}
                                backgroundColor={'var(--color-blue)'}
                                labelColor={'var(--color-white)'}
                                icon={<Search color='var(--color-white)' style={{ color: 'var(--color-white)' }} />}
                                onClick={() => getCharges()}
                            />
                        </div>
                    }
                    elements={
                        <div style={{
                            margin: '20px'
                        }}>
                            {!matches15 && <div style={{ display: 'flex', justifyContent: 'center', borderBottom: '20px' }}>
                                <M_Button
                                    bold
                                    normal
                                    hoverEffect
                                    label={t('LoadCharges')}
                                    borderColor={'var(--color-blue)'}
                                    backgroundColor={'var(--color-blue)'}
                                    labelColor={'var(--color-white)'}
                                    icon={<Search color='var(--color-white)' style={{ color: 'var(--color-white)' }} />}
                                    onClick={() => getCharges()}
                                />
                            </div>}
                            <M_SimpleTable
                                rowGroupMode={'subheader'}
                                groupField={'lumpSumCode'}
                                headerTemplate={(obj, eventData) => {
                                    const calcProfit = calculateTotalProfit(obj, eventData)

                                    if (obj?.lumpSumCode) {
                                        return (
                                            <span style={{ display: matches10 && 'grid' || 'flex', gridTemplateColumns: 'auto auto auto auto auto auto auto auto', backgroundColor: 'var(--color-grey-light)', borderRadius: '15px' }}>
                                                <b style={{ padding: matches10 && '10px 10px 10px 50px' || '10px' }}>{obj?.lumpSumCode}</b>
                                                {matches8 && <div></div>}
                                                <b style={{ padding: '10px 0px', marginLeft: '50px' }}>{obj?.lumpSumName}</b>
                                                <b style={{ padding: '10px', marginLeft: '50px', display: 'flex' }}>{t('TotalCost')} : {calculateTotalSum(obj, eventData, 'costValue')}{data?.quoteCurrencyCode}</b>
                                                <b style={{ padding: matches10 && '10px 10px 10px 50px' || '10px', marginLeft: '50px' }}>{t('TotalSales')} : {calculateTotalSum(obj, eventData, 'salesValue')}{data?.quoteCurrencyCode}</b>
                                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                                    <b style={{ padding: '10px', marginLeft: '50px' }}>Profit</b>
                                                    <b style={{ padding: '10px 0px', color: calcProfit > 0 ? 'var(--color-green-light)' : calcProfit < 0 && 'var(--color-red)' }}>{calcProfit} {data?.quoteCurrencyCode}</b>
                                                </span>
                                            </span>
                                        )
                                    }
                                }}
                                footerTemplate={(obj) => {
                                    if (obj?.lumpSumCode) {
                                        return (
                                            <td colSpan="11" style={{ backgroundColor: 'var(--color-blue-dark)' }} >
                                                <span style={{ display: 'flex', backgroundColor: 'var(--color-blue-dark)', height: '1px' }}></span>
                                            </td>
                                        )
                                    }
                                }}
                                rows={data['charges'] && data['charges'] || []}
                                columns={[...ChargesFields.map((field, index) => {
                                    return { header: field.display, field: field.code, ...field, body: (row) => chargesElements(row, field, index) }
                                }),
                                {
                                    'header': '',
                                    'frozen': true,
                                    'alignFrozen': 'Right',
                                    'body': (row) => row.id !== data.charges[data.charges.length - 1].id && (
                                        <div>
                                            <M_Button none icon={<Settings style={{ color: 'var(--color-blue)' }} />} onClick={() => settingsCharges(row)} />
                                            <M_Button none icon={<Close style={{ color: 'var(--color-red)' }} />} onClick={() => deleteCharges(row)} />
                                        </div>
                                    ) || <></>
                                },
                                    // { 'header': '', 'body': (row) => row.id !== data.charges[data.charges.length - 1].id && () || <></> }
                                ]}
                            />
                        </div>
                    }
                />
                <div style={{ margin: '25px' }}></div>
                <M_Fieldset
                    labelInside
                    label={<div style={{ display: 'flex', alignItems: 'center', fontSize: '25px', marginLeft: '10px' }}><FunctionsOutlined style={{ marginRight: '10px', scale: '1.3' }} />  {t("Totalizador")}</div>}
                    elements={
                        <div style={{ display: 'grid', gridTemplateColumns: !matches14 && 'auto' || !matches10 && 'auto auto' || 'auto auto auto', justifyContent: 'space-evenly', scale: !matches15 && '.8' || !matches14 && '1' || !matches11 && '.9' || !matches10 && '1' || !matches7 && '.8' || !matches5 && '.9' }}>
                            {Totalizador.map((total, index) => (
                                <M_Fieldset
                                    key={index}
                                    labelInside
                                    elements={
                                        <div style={{ display: 'flex', flexDirection: !matches16 && 'column ', alignItems: 'center', width: matches16 && '400px', }}>
                                            <h2 style={{ color: 'var(--color-blue-dark)', width: matches16 && '250px', marginLeft: '5px' }}>
                                                {total.display} :
                                            </h2>
                                            <h2 style={{ height: '50px', display: 'flex', alignItems: 'center', color: total.code === 'totalProfit' && getProfit() > 0 ? 'var(--color-green-light)' : total.code === 'totalProfit' && getProfit() < 0 ? 'var(--color-red)' : null }}>
                                                {total.code === 'totalCharges' && data?.charges?.filter(obj => obj?.serviceCode !== '').length}
                                                {total.code === 'totalCost' && `${getSum('costValue').toFixed(2)} ${data['totalCurrency']}`}
                                                {total.code === 'totalCurrency' &&
                                                    fields({ display: '', code: 'totalCurrency', type: 'foreignKey', entity: 'Currency', filterField: 'code', labelFields: ['Code'], fields: [{ key: 'Code', value: 'totalCurrency' }, { key: 'Id', value: 'totalCurrencyId' }] },
                                                        index, data, setData, true, null, '150px', currencyOptions, 0
                                                    )}
                                                {total.code === 'totalSales' && `${getSum('salesValue').toFixed(2)} ${data['totalCurrency']}`}
                                                {total.code === 'totalMarkup' && `${getMarkup()} %`}
                                                {total.code === 'totalProfit' && `${getProfit()} ${data['totalCurrency']}`}
                                            </h2>
                                        </div>
                                    }
                                />
                            ))}
                        </div>
                    }
                />
            </div >
            <M_ElementDrawer
                open={open}
                setOpen={closeSettings}
                onClose={closeSettings}
                element={
                    <div style={{ margin: '0px 5px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '10px 0px', }}>
                            <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <h2 style={{ color: ctx.secondaryColor, display: 'flex', alignItems: 'center', marginTop: '0px' }}>
                                    <Settings style={{ marginRight: '5px', fontSize: '30px', }} />
                                    {t("QuoteSettings")}
                                </h2>
                            </span>
                            <div style={{ border: `1px solid ${ctx.primaryColor}`, width: '90%' }}></div>
                        </div>
                        <div style={{ margin: '50px' }}></div>
                        <M_Fieldset
                            labelInside
                            label={<div style={{ display: 'flex', alignItems: 'center', fontSize: '25px', marginLeft: '10px' }}> {t("Restricions")}</div>}
                            elements={
                                <div style={{ display: 'grid', gridTemplateColumns: 'auto auto ', justifyContent: 'space-evenly' }}>
                                    {RestrictionsFields.map((field, index) => {
                                        return <div key={index}>{fields(field, index, passedRow, setPassedRow)}</div>
                                    })}
                                </div>
                            }
                        />
                        <div style={{ margin: '50px' }}></div>
                        <M_Fieldset
                            labelInside
                            label={<div style={{ display: 'flex', alignItems: 'center', fontSize: '25px', marginLeft: '10px' }}> {t("Manifest")}</div>}
                            elements={
                                <div style={{ display: 'grid', gridTemplateColumns: 'auto auto ', justifyContent: 'space-evenly' }}>
                                    {ManifestFields.map((field, index) => {
                                        return <div key={index}>{fields(field, index, passedRow, setPassedRow)}</div>
                                    })}
                                </div>
                            }
                        />
                        <div style={{ margin: '50px' }}></div>
                        <M_Fieldset
                            labelInside
                            label={<div style={{ display: 'flex', alignItems: 'center', fontSize: '25px', marginLeft: '10px' }}> {t("Details")}</div>}
                            elements={
                                <div style={{ display: 'grid', gridTemplateColumns: 'auto auto ', justifyContent: 'space-evenly' }}>
                                    {DetailsFields.map((field, index) => {
                                        return <div key={index}>{fields(field, index, passedRow, setPassedRow, null, null, null, field?.options)}</div>
                                    })}
                                </div>
                            }
                        />
                        <div style={{ margin: '50px' }}></div>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginRight: '10px', marginLeft: '10px' }} >
                            <div></div>
                            <div style={{ display: 'flex' }}>
                                <M_Button
                                    hoverEffect
                                    width={20}
                                    label={t("Save")}
                                    onClick={() => saveSettings()}
                                    backgroundColor={'var(--color-green)'}
                                    labelColor={'var(--color-white)'}
                                />
                                <M_Button
                                    hoverEffect
                                    width={15}
                                    label={t("Cancel")}
                                    onClick={() => closeSettings()}
                                    backgroundColor={'var(--color-red)'}
                                    labelColor={'var(--color-white)'}
                                />
                            </div>
                        </div>
                    </div>
                }
            />
        </div >
    )
}
